<template>
  <!-- <div :class="['scrollBanner', !show || manualClose ? 'scroll-banner-small' : '']">
    <div
      class="scroll_con animated"
      :class="{
        fadeInUp: show && !manualClose,
        fadeOutDown: !show || manualClose,
      }"
    >
      <template v-if="show && !manualClose">
        <div class="big-elephant">
          <img
            src="https://asset.tsign.cn/apps/esign-nuxt-website/prod/1.0.9/img/8aeb8ee.svg"
            alt="关闭按钮"
            class="close-btn"
            @click="manualClose = true"
          />
          <img class="esign-elephant" src="https://asset.tsign.cn/apps/esign-nuxt-website/prod/1.0.9/img/0ec1e51.png" />
        </div>
        <div class="form-wrapper">
          <input
            :class="[(isClick && name == '') || name == '请输入您的姓名(中文)' ? 'active_input' : '']"
            v-model="name"
            type="text"
            placeholder="您的姓名"
            @focus="clearData(0)"
            @blur="onfousFun()"
          />
          <input
            :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active_input' : '']"
            v-model="companyName"
            type="text"
            placeholder="公司名称"
            @focus="clearData(1)"
            @blur="onfousFun()"
          />
          <input
            :class="[(isClick && phoneNumber == '') || phoneNumber == '请输入您的联系方式' ? 'active_input' : '']"
            v-model="phoneNumber"
            type="text"
            placeholder="手机号码"
            @focus="clearData(2)"
            @blur="onfousFun()"
          />
          <input
            :class="[(isClick && phoneCode == '') || phoneCode == '请输入验证码' ? 'active_input last' : 'last']"
            v-model="phoneCode"
            maxlength="6"
            class="send_code"
            placeholder="验证码"
            @focus="clearData(3)"
            @blur="onfousFun()"
          />
          <div :class="[codeName == '获取验证码' ? 'active_c1' : 'active_c']" class="send_code_tx" @click="handleFetchCodeClick()">
            {{ codeName }}
          </div>
          <div id="man-machine-slide"></div>
          <div class="btn-wrapper">
            <div class="item_line agreement-line" v-if="userAgreement.enable">
              <label class="wrapper">
                <input type="checkbox" v-model="agreement" /><span>我已阅读并同意<a :href="userAgreement.link" target="_blank">《隐私协议》</a></span>
              </label>
              <div v-show="showErrorTip" class="error-tip">请先阅读并同意协议</div>
            </div>
            <div class="try_button" @click="handleSendInfoBtnClick" data-agl-cvt="5">提交试用信息</div>
          </div>
        </div>
      </template>
      <img
        class="small-elephant animated"
        :class="{
          fadeInUp: show && manualClose,
          fadeOutDown: !show && manualClose,
        }"
        v-show="manualClose"
        src="https://asset.tsign.cn/apps/esign-nuxt-website/prod/1.0.9/img/5e6efc7.png"
        @click="manualClose = false"
      />
    </div>
  </div> -->
  <div></div>
</template>

<script>
import formMixin from '../mixins/form.js'

export default {
  props: {
    show: Boolean,
    landingPageName: String,
  },
  mixins: [formMixin],
  data() {
    return {
      manualClose: false,
      closeForm: true,
    }
  },
  watch: {
    closeForm(v, oldV) {
      this.$emit('setShowSuccessDialog', !v)
    },
  },
}
</script>

<style lang="less" scoped>
.scrollBanner {
  height: 140px;
  width: 100%;
  bottom: 0;
  left: 0;
  text-align: center;
  z-index: 11;
  position: fixed;
  overflow: auto;
  // min-width: 1200px;

  .big-elephant {
    display: flex;
    align-items: flex-start;
  }

  .small-elephant {
    position: absolute;
    bottom: 6px;
    right: -100px;
    width: 100px;
    cursor: pointer;
  }

  .esign-elephant {
    width: 187px;
  }

  .close-btn {
    width: 26px;
    height: 26px;
    transform: rotateZ(0);
    transition: transform 0.5s;
    cursor: pointer;

    &:hover {
      transform: rotateZ(90deg);
    }
  }

  .scroll_title {
    width: 1200px;
    font-size: 30px;
    color: #fff;
    text-align: center;
    padding-top: 30px;
    margin: auto;
  }

  .scroll_con {
    margin: 0;
    padding: 0 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    background: #000;
    width: 100%;
  }

  .warning-info {
    padding-left: 400px;
    font-size: 12px;
    color: #e61717;
  }

  input {
    background: #fff;
    outline: 0;
    border: 0;
    border-radius: 3px;
    width: 200px;
    height: 48px;
    padding-left: 15px;
    margin-left: 12px;

    &::placeholder {
      padding-left: 15px;
      color: #333;
    }

    &::-webkit-input-placeholder {
      padding-left: 15px;
      color: #333;
    }

    &::-moz-placeholder {
      padding-left: 15px;
      color: #333;
    }

    &:-moz-placeholder {
      padding-left: 15px;
      color: #333;
    }

    &:-ms-input-placeholder {
      padding-left: 15px;
      color: #333;
    }
  }

  .last {
    margin-right: 0;
  }

  .active_input {
    border: 1px solid #e61717;
    color: #e61717;
  }

  .send_code {
    width: 127px;
    background: #fff;
    outline: 0;
    border: 0;
    margin-left: 20px;
    padding-left: 15px;
    border-radius: 3px 0 0 3px;
  }

  .send_code_tx {
    min-width: 113px;
    height: 48px;
    background: #e8e8ed;
    line-height: 48px;
    font-size: 14px;
    cursor: pointer;
    border-radius: 0 3px 3px 0;
    white-space: nowrap;
    text-align: center;
  }

  .active_c {
    color: #ccc;
  }

  .active_c1 {
    color: #e61717;
  }

  .try_button {
    color: #fff;
    font-size: 20px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
    min-width: 140px;
    height: 48px;
    background-color: #e61717;
    border-radius: 3px;
    margin-left: 12px;
    white-space: nowrap;
  }

  .bg_active0 {
    background: #e61717 !important;
  }

  .bg_active1 {
    background: rgba(230, 23, 23, 0.5) !important;
  }
  .form-wrapper {
    display: flex;
    align-items: flex-end;
  }
  .item_line.agreement-line {
    height: auto;
    color: #fff;
    margin-bottom: 10px;
    .wrapper {
      display: flex;
      align-items: center;
    }
    input {
      width: 14px;
      height: 14px;
      display: inline-block;
    }
    span {
      font-size: 13px;
      margin-left: 6px;
    }
    a {
      display: inline-block;
      font-size: 13px;
      color: #1890ff;
    }
    .error-tip {
      font-size: 12px;
      color: red;
      text-align: right;
      margin-top: 4px;
    }
  }
}

@keyframes fadeOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(-100%, 0, 0);
  }
}

.fadeOutDown {
  animation-name: fadeOutDown;
}

@keyframes fadeInUp {
  0% {
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp {
  animation-name: fadeInUp;
}

.animated {
  animation-duration: 0.4s;
  animation-fill-mode: both;
}
.scroll-banner-small {
  width: 100px;
  height: 80px;
}

@media (print), (prefers-reduced-motion: reduce) {
  .animated {
    animation-duration: 1ms !important;
    transition-duration: 1ms !important;
    animation-iteration-count: 1 !important;
  }
}

/deep/ .nc_scale {
  border-radius: 3px;

  .btn_ok {
    border-radius: 0 3px 3px 0;
  }
}
@media screen and (max-width: 768px) {
  .scrollBanner {
    display: none;
  }
}
</style>

<style lang="less">
@import '../mixins/bot.less';

.scrollBanner {
  .bot_slide_pc(@slideHeight: 48px, @slideWidth: 240px, @containerMargin: 0 0 0 12px);
}
</style>
